import { render } from "./AddCredential.vue?vue&type=template&id=5db33312"
import script from "./AddCredential.vue?vue&type=script&lang=js"
export * from "./AddCredential.vue?vue&type=script&lang=js"

import "./AddCredential.vue?vue&type=style&index=0&id=5db33312&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__